module.exports = __webpack_public_path__ + "static/media/anurag.5b1e69fe.jpg";